import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function RosaAccounting() {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    const email = sessionStorage.getItem("userEmail");
    if (!email) navigate("/signin");
    else setUserEmail(email);
  }, [navigate]);

  // ? Navigation handlers (YOUR REQUIREMENT)
  const handleRosaAC = () => {
    navigate("/rosaac");
  };

  const handleMainPage = () => {
    navigate("/screens");
  };

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h2 style={{ color: "blue" }}>Rosa Accounting Screen</h2>

      <p><b>Signed in as:</b> {userEmail}</p>

      <button onClick={handleRosaAC} style={buttonStyle}>
        RosaAC
      </button>

      <br />

      <button onClick={handleMainPage} style={buttonStyle}>
        Main Screen
      </button>
    </div>
  );
}

const buttonStyle = {
  padding: "15px 30px",
  backgroundColor: "blue",
  color: "white",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "16px",
  marginBottom: "20px",
};

export default RosaAccounting;
